module.exports = __webpack_public_path__ + "img/23.41bb02a1.png";